module.exports = __webpack_public_path__ + "img/flying-kid-mobile.cbe78e2a.png";